import { render, staticRenderFns } from "./ThreadListItem.vue?vue&type=template&id=355bc9ac&scoped=true"
import script from "./ThreadListItem.vue?vue&type=script&lang=ts"
export * from "./ThreadListItem.vue?vue&type=script&lang=ts"
import style0 from "./ThreadListItem.vue?vue&type=style&index=0&id=355bc9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355bc9ac",
  null
  
)

export default component.exports